import { connect } from 'react-redux';
// component
import PlatformSelection from './platform-selection.component';

// actions
import { setPlatform } from './platform-selection.actions';

// types
import { State } from 'widgets/free-content/root/root.reducers';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { Dispatch } from 'types/dispatch';
// utils
import { sortByOrder } from 'utils/array';
// constants
import { PLATFORMS_ORDER } from 'constants/platform';

const mapStateToProps = (state: State) => ({
    eventPlatforms: sortByOrder(state.event?.data?.platforms ?? [], PLATFORMS_ORDER, 'platform'),
    shouldInheritStyles: state.config.shouldInheritStyles,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setPlatform: (platformId: PLATFORM_TYPES): void => {
        dispatch(setPlatform(platformId));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlatformSelection);
